// ArtworkContext.js
import { useState } from 'preact/hooks';
import { createContext } from 'preact/compat';
import { ArtworkId } from '../renderer/artworks';
import { useLocalStorageState } from 'ahooks';

export enum ArtworkState {
  NONE,
  PLACING,
  LOADING,
  VIEWING,
}

type ArtworkContextType = {
  artworkState: ArtworkState;
  setArtworkState: React.Dispatch<React.SetStateAction<ArtworkState>>;
  currentArtwork: ArtworkId | undefined;
  setCurrentArtwork: React.Dispatch<React.SetStateAction<ArtworkId | undefined>>;
  viewedArtworks: ArtworkId[] | undefined;
  setViewedArtworks: React.Dispatch<React.SetStateAction<ArtworkId[] | undefined>>;

};

export const ArtworkContext = createContext<ArtworkContextType>({
  artworkState: ArtworkState.NONE,
  setArtworkState: () => { },
  viewedArtworks: [],
  setCurrentArtwork: () => { },
  setViewedArtworks: () => { },
  currentArtwork: undefined,
});

export const ArtworkProvider = ({ children }) => {
  const [currentArtwork, setCurrentArtwork] = useState<ArtworkId | undefined>(undefined);
  const [artworkState, setArtworkState] = useState<ArtworkState>(ArtworkState.NONE);
  const [viewedArtworks, setViewedArtworks] = useLocalStorageState<ArtworkId[] | undefined>('viewedArtworks', {
    defaultValue: [],
  });

  return (
    <ArtworkContext.Provider
      value={{
        artworkState,
        setArtworkState,
        currentArtwork,
        setCurrentArtwork,
        viewedArtworks,
        setViewedArtworks,
      }}
    >
      {children}
    </ArtworkContext.Provider>
  );
};
